import transformList from './list';

export default {
    list: transformList,
};
